import { CssBaseline as NovaCssBaseline } from '@fme-nova/components'
import { CssBaseline as MuiCssBaseline } from '@mui/material'

import { createComponentWrapperWithRef } from './ComponentLibraryWrapper'

const ResetCSS = createComponentWrapperWithRef(
  {
    mui: MuiCssBaseline,
    nova: NovaCssBaseline,
  },
  'ResetCSS',
)

export default ResetCSS
